export const filterLimitedRegions = [
  {
    code: 'world',
    native_language: {
      code: 'all',
      languageName: 'All Languages',
    },
    name: 'Worldwide',
    flag_position: '0 0',
  },
  {
    code: 'au',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'Australia',
    flag_position: '-208px 0',
    flag: '<svg width="100%" height="100%" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero" fill="none"><path d="M22 11c0 6.075-4.925 11-11 11S0 17.075 0 11C0 11.003 11 .001 11 0c6.075 0 11 4.925 11 11z" fill="#0052B4"></path><path d="M11 5.74V0h-.002C4.924.001 0 4.925 0 11h5.74V7.768L8.97 11h2l.03-.03V8.972L7.768 5.739H11z" fill="#F0F0F0"></path><g fill="#D80027"><path d="M5.565 1.435c-1.72.98-3.15 2.41-4.13 4.13V11h2.87V4.304H11v-2.87H5.565z"></path><path d="M11 9.647L7.092 5.74H5.739L11 11V9.647z"></path></g><g fill="#F0F0F0"><path d="M6.634 12.913l.604 1.262L8.6 13.86l-.61 1.26 1.096.869-1.365.307.004 1.4-1.092-.876-1.091.876.003-1.4-1.365-.307 1.097-.87-.61-1.259 1.362.315zM16.47 15.304l.301.632.682-.158-.306.63.549.434-.683.154.002.7-.546-.438-.546.438.002-.7-.682-.154.548-.435-.305-.629.681.158zM13.661 8.609l.302.63.682-.157-.306.63.549.435-.683.153.002.7-.546-.438-.546.438.002-.7-.682-.153.548-.435-.305-.63.681.158zM16.47 4.783l.301.63.682-.157-.306.63.549.434-.683.154.002.7-.546-.438-.546.438.002-.7-.682-.154.548-.434-.305-.63.681.158zM18.922 7.652l.302.631.682-.157-.306.63.548.434-.682.154.002.7-.546-.438-.546.437.002-.7-.682-.153.548-.435-.305-.63.681.158zM17.168 11l.238.73h.768l-.622.452.238.731-.622-.452-.621.452.237-.73-.622-.452h.769z"></path></g></g></svg>',
  },
  {
    code: 'be',
    native_language: {
      code: 'nl',
      languageName: 'Dutch',
    },
    name: 'Belgium',
    flag_position: '-48px -11px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#FFDA44;" d="M345.043,15.923C317.31,5.633,287.314,0,256,0s-61.31,5.633-89.043,15.923L144.696,256 l22.261,240.077C194.69,506.368,224.686,512,256,512s61.31-5.632,89.043-15.923L367.304,256L345.043,15.923z"/> <path style="fill:#D80027;" d="M512,256c0-110.07-69.472-203.906-166.957-240.076v480.155C442.528,459.906,512,366.072,512,256z"/> <path d="M0,256c0,110.072,69.472,203.906,166.957,240.078V15.924C69.472,52.094,0,145.93,0,256z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'ca',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'Canada',
    flag_position: '-48px -22px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <g> <path style="fill:#D80027;" d="M512,256c0-101.494-59.065-189.19-144.696-230.598v461.195C452.935,445.19,512,357.494,512,256z"/> <path style="fill:#D80027;" d="M0,256c0,101.494,59.065,189.19,144.696,230.598V25.402C59.065,66.81,0,154.506,0,256z"/> <polygon style="fill:#D80027;" points="300.522,289.391 345.043,267.13 322.783,256 322.783,233.739 278.261,256 300.522,211.478 278.261,211.478 256,178.087 233.739,211.478 211.478,211.478 233.739,256 189.217,233.739 189.217,256 166.957,267.13 211.478,289.391 200.348,311.652 244.87,311.652 244.87,345.043 267.13,345.043 267.13,311.652 311.652,311.652 \t"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'us',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'United States',
    flag_position: '-64px -154px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <g> <path style="fill:#D80027;" d="M244.87,256H512c0-23.106-3.08-45.49-8.819-66.783H244.87V256z"/> <path style="fill:#D80027;" d="M244.87,122.435h229.556c-15.671-25.572-35.708-48.175-59.07-66.783H244.87V122.435z"/> <path style="fill:#D80027;" d="M256,512c60.249,0,115.626-20.824,159.356-55.652H96.644C140.374,491.176,195.751,512,256,512z"/> <path style="fill:#D80027;" d="M37.574,389.565h436.852c12.581-20.529,22.338-42.969,28.755-66.783H8.819 C15.236,346.596,24.993,369.036,37.574,389.565z"/> </g> <path style="fill:#0052B4;" d="M118.584,39.978h23.329l-21.7,15.765l8.289,25.509l-21.699-15.765L85.104,81.252l7.16-22.037 C73.158,75.13,56.412,93.776,42.612,114.552h7.475l-13.813,10.035c-2.152,3.59-4.216,7.237-6.194,10.938l6.596,20.301l-12.306-8.941 c-3.059,6.481-5.857,13.108-8.372,19.873l7.267,22.368h26.822l-21.7,15.765l8.289,25.509l-21.699-15.765l-12.998,9.444 C0.678,234.537,0,245.189,0,256h256c0-141.384,0-158.052,0-256C205.428,0,158.285,14.67,118.584,39.978z M128.502,230.4 l-21.699-15.765L85.104,230.4l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822l-21.7,15.765L128.502,230.4z M120.213,130.317l8.289,25.509l-21.699-15.765l-21.699,15.765l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822 L120.213,130.317z M220.328,230.4l-21.699-15.765L176.93,230.4l8.289-25.509l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822 l-21.7,15.765L220.328,230.4z M212.039,130.317l8.289,25.509l-21.699-15.765l-21.699,15.765l8.289-25.509l-21.7-15.765h26.822 l8.288-25.509l8.288,25.509h26.822L212.039,130.317z M212.039,55.743l8.289,25.509l-21.699-15.765L176.93,81.252l8.289-25.509 l-21.7-15.765h26.822l8.288-25.509l8.288,25.509h26.822L212.039,55.743z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'gb',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'United Kingdom',
    flag_position: '-160px -44px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <g> <path style="fill:#0052B4;" d="M52.92,100.142c-20.109,26.163-35.272,56.318-44.101,89.077h133.178L52.92,100.142z"/> <path style="fill:#0052B4;" d="M503.181,189.219c-8.829-32.758-23.993-62.913-44.101-89.076l-89.075,89.076H503.181z"/> <path style="fill:#0052B4;" d="M8.819,322.784c8.83,32.758,23.993,62.913,44.101,89.075l89.074-89.075L8.819,322.784L8.819,322.784 z"/> <path style="fill:#0052B4;" d="M411.858,52.921c-26.163-20.109-56.317-35.272-89.076-44.102v133.177L411.858,52.921z"/> <path style="fill:#0052B4;" d="M100.142,459.079c26.163,20.109,56.318,35.272,89.076,44.102V370.005L100.142,459.079z"/> <path style="fill:#0052B4;" d="M189.217,8.819c-32.758,8.83-62.913,23.993-89.075,44.101l89.075,89.075V8.819z"/> <path style="fill:#0052B4;" d="M322.783,503.181c32.758-8.83,62.913-23.993,89.075-44.101l-89.075-89.075V503.181z"/> <path style="fill:#0052B4;" d="M370.005,322.784l89.075,89.076c20.108-26.162,35.272-56.318,44.101-89.076H370.005z"/> </g> <g> <path style="fill:#D80027;" d="M509.833,222.609h-220.44h-0.001V2.167C278.461,0.744,267.317,0,256,0 c-11.319,0-22.461,0.744-33.391,2.167v220.44v0.001H2.167C0.744,233.539,0,244.683,0,256c0,11.319,0.744,22.461,2.167,33.391 h220.44h0.001v220.442C233.539,511.256,244.681,512,256,512c11.317,0,22.461-0.743,33.391-2.167v-220.44v-0.001h220.442 C511.256,278.461,512,267.319,512,256C512,244.683,511.256,233.539,509.833,222.609z"/> <path style="fill:#D80027;" d="M322.783,322.784L322.783,322.784L437.019,437.02c5.254-5.252,10.266-10.743,15.048-16.435 l-97.802-97.802h-31.482V322.784z"/> <path style="fill:#D80027;" d="M189.217,322.784h-0.002L74.98,437.019c5.252,5.254,10.743,10.266,16.435,15.048l97.802-97.804 V322.784z"/> <path style="fill:#D80027;" d="M189.217,189.219v-0.002L74.981,74.98c-5.254,5.252-10.266,10.743-15.048,16.435l97.803,97.803 H189.217z"/> <path style="fill:#D80027;" d="M322.783,189.219L322.783,189.219L437.02,74.981c-5.252-5.254-10.743-10.266-16.435-15.047 l-97.802,97.803V189.219z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'fr',
    native_language: {
      code: 'fr',
      languageName: 'Français',
    },
    name: 'France',
    flag_position: '-128px -44px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#D80027;" d="M512,256c0-110.071-69.472-203.906-166.957-240.077v480.155C442.528,459.906,512,366.071,512,256z"/> <path style="fill:#0052B4;" d="M0,256c0,110.071,69.473,203.906,166.957,240.077V15.923C69.473,52.094,0,145.929,0,256z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'de',
    native_language: {
      code: 'de',
      languageName: 'Deutsch',
    },
    name: 'Germany',
    flag_position: '-64px -33px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#FFDA44;" d="M15.923,345.043C52.094,442.527,145.929,512,256,512s203.906-69.473,240.077-166.957L256,322.783 L15.923,345.043z"/> <path d="M256,0C145.929,0,52.094,69.472,15.923,166.957L256,189.217l240.077-22.261C459.906,69.472,366.071,0,256,0z"/> <path style="fill:#D80027;" d="M15.923,166.957C5.633,194.69,0,224.686,0,256s5.633,61.31,15.923,89.043h480.155 C506.368,317.31,512,287.314,512,256s-5.632-61.31-15.923-89.043H15.923z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'in',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'India',
    flag_position: '-96px -66px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#FF9811;" d="M256,0C154.506,0,66.81,59.065,25.402,144.696h461.195C445.19,59.065,357.493,0,256,0z"/> <path style="fill:#6DA544;" d="M256,512c101.493,0,189.19-59.065,230.598-144.696H25.402C66.81,452.935,154.506,512,256,512z"/> <circle style="fill:#0052B4;" cx="256" cy="256" r="89.043"/> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="55.652"/> <polygon style="fill:#0052B4;" points="256,187.326 273.169,226.264 315.473,221.663 290.337,256 315.473,290.337 273.169,285.736 256,324.674 238.831,285.736 196.527,290.336 221.663,256 196.527,221.663 238.831,226.264 "/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'it',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'Italy',
    flag_position: '-176px -66px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#D80027;" d="M512,256c0-110.071-69.472-203.906-166.957-240.077v480.155C442.528,459.906,512,366.071,512,256z"/> <path style="fill:#6DA544;" d="M0,256c0,110.071,69.472,203.906,166.957,240.077V15.923C69.472,52.094,0,145.929,0,256z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'my',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'Malaysia',
    flag_position: '-160px -99px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <g> <path style="fill:#D80027;" d="M244.87,256H512c0-23.107-3.08-45.489-8.819-66.783H244.87V256z"/> <path style="fill:#D80027;" d="M244.87,122.435h229.556c-15.671-25.572-35.706-48.175-59.069-66.783H244.87V122.435z"/> <path style="fill:#D80027;" d="M256,512c60.249,0,115.626-20.824,159.357-55.652H96.643C140.374,491.176,195.751,512,256,512z"/> <path style="fill:#D80027;" d="M37.574,389.565h436.852c12.581-20.528,22.337-42.969,28.755-66.783H8.819 C15.236,346.596,24.993,369.037,37.574,389.565z"/> </g> <path style="fill:#0052B4;" d="M256,256c0-141.384,0-158.052,0-256C114.616,0,0,114.616,0,256H256z"/> <g> <path style="fill:#FFDA44;" d="M170.234,219.13c-34.962,0-63.304-28.343-63.304-63.304s28.343-63.304,63.304-63.304 c10.901,0,21.158,2.757,30.113,7.609c-14.048-13.737-33.26-22.217-54.461-22.217c-43.029,0-77.913,34.883-77.913,77.913 s34.884,77.913,77.913,77.913c21.201,0,40.413-8.48,54.461-22.217C191.392,216.373,181.136,219.13,170.234,219.13z"/> <polygon style="fill:#FFDA44;" points="188.073,111.304 199.312,134.806 224.693,128.942 213.327,152.381 233.739,168.568 208.325,174.297 208.396,200.348 188.073,184.05 167.749,200.348 167.819,174.297 142.405,168.568 162.817,152.381 151.45,128.942 176.833,134.806 \t"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'sg',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'Singapore',
    flag_position: '-48px -132px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#D80027;" d="M0,256.001C0,114.616,114.616,0,256,0s256,114.616,256,256.001"/> <g> <path style="fill:#F0F0F0;" d="M155.826,133.564c0-37.298,26.213-68.456,61.217-76.101c-5.38-1.174-10.961-1.811-16.696-1.811 c-43.031,0-77.913,34.882-77.913,77.913s34.882,77.913,77.913,77.913c5.733,0,11.315-0.637,16.696-1.812 C182.039,202.021,155.826,170.863,155.826,133.564z"/> <polygon style="fill:#F0F0F0;" points="256,61.217 261.526,78.222 279.407,78.222 264.94,88.733 270.466,105.738 256,95.229 241.534,105.738 247.06,88.733 232.594,78.222 250.474,78.222 \t"/> <polygon style="fill:#F0F0F0;" points="212.625,94.608 218.15,111.614 236.031,111.614 221.565,122.124 227.091,139.129 212.625,128.62 198.157,139.129 203.684,122.124 189.217,111.614 207.098,111.614 \t"/> <polygon style="fill:#F0F0F0;" points="299.376,94.608 304.903,111.614 322.783,111.614 308.316,122.124 313.843,139.129 299.376,128.62 284.91,139.129 290.436,122.124 275.97,111.614 293.85,111.614 \t"/> <polygon style="fill:#F0F0F0;" points="282.681,144.695 288.207,161.701 306.087,161.701 291.621,172.211 297.147,189.216 282.681,178.707 268.215,189.216 273.741,172.211 259.275,161.701 277.154,161.701 \t"/> <polygon style="fill:#F0F0F0;" points="229.32,144.695 234.845,161.701 252.727,161.701 238.26,172.211 243.787,189.216 229.32,178.707 214.853,189.216 220.379,172.211 205.913,161.701 223.794,161.701 \t"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'es',
    native_language: {
      code: 'es',
      languageName: 'Español',
    },
    name: 'Spain',
    flag_position: '0 -44px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#FFDA44;" d="M0,256c0,31.314,5.633,61.31,15.923,89.043L256,367.304l240.077-22.261 C506.367,317.31,512,287.314,512,256s-5.633-61.31-15.923-89.043L256,144.696L15.923,166.957C5.633,194.69,0,224.686,0,256z"/> <g> <path style="fill:#D80027;" d="M496.077,166.957C459.906,69.473,366.071,0,256,0S52.094,69.473,15.923,166.957H496.077z"/> <path style="fill:#D80027;" d="M15.923,345.043C52.094,442.527,145.929,512,256,512s203.906-69.473,240.077-166.957H15.923z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'ch',
    native_language: {
      code: 'de',
      languageName: 'Deutsch',
    },
    name: 'Switzerland',
    flag_position: '-128px -22px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#D80027;" cx="256" cy="256" r="256"/> <polygon style="fill:#F0F0F0;" points="389.565,211.479 300.522,211.479 300.522,122.435 211.478,122.435 211.478,211.479 122.435,211.479 122.435,300.522 211.478,300.522 211.478,389.565 300.522,389.565 300.522,300.522 389.565,300.522 "/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'pl',
    native_language: {
      code: 'pl',
      languageName: 'Polish',
    },
    name: 'Poland',
    flag_position: '-240px -110px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#D80027;" d="M512,256c0,141.384-114.616,256-256,256S0,397.384,0,256"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'pk',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'Pakistan',
    flag_position: '-224px -110px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <g> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#F0F0F0;" d="M0,256c0,97.035,53.989,181.454,133.565,224.873V31.127C53.989,74.546,0,158.965,0,256z"/> </g> <path style="fill:#496E2D;" d="M256,0c-44.35,0-86.064,11.283-122.435,31.127v449.745C169.936,500.717,211.65,512,256,512 c141.384,0,256-114.616,256-256S397.384,0,256,0z"/> <g> <path style="fill:#F0F0F0;" d="M365.453,298.337c-32.387,23.401-77.613,16.117-101.013-16.269 c-23.402-32.388-16.117-77.613,16.27-101.013c10.098-7.296,21.444-11.609,32.987-13.108c-22.207-3.321-45.682,1.683-65.319,15.872 c-39.86,28.802-48.827,84.463-20.026,124.325c28.801,39.859,84.463,48.827,124.325,20.023 c19.639-14.189,31.76-34.902,35.578-57.031C383.209,281.622,375.552,291.04,365.453,298.337z"/> <polygon style="fill:#F0F0F0;" points="364.066,166.959 382.31,186.62 406.646,175.348 393.583,198.772 411.826,218.435 385.51,213.25 372.448,236.676 369.247,210.046 342.931,204.861 367.268,193.589 \t"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'ua',
    native_language: {
      code: 'uk',
      languageName: 'Ukranian',
    },
    name: 'Ukraine',
    flag_position: '-16px -154px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#FFDA44;" cx="256" cy="256" r="256"/> <path style="fill:#338AF3;" d="M0,256C0,114.616,114.616,0,256,0s256,114.616,256,256"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'br',
    native_language: {
      code: 'pt',
      languageName: 'Português',
    },
    name: 'Brazil',
    flag_position: '-192px -11px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#6DA544;" cx="256" cy="256" r="256"/> <polygon style="fill:#FFDA44;" points="256,100.174 467.478,256 256,411.826 44.522,256 "/> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="89.043"/> <g> <path style="fill:#0052B4;" d="M211.478,250.435c-15.484,0-30.427,2.355-44.493,6.725c0.623,48.64,40.227,87.884,89.015,87.884 c30.168,0,56.812-15.017,72.919-37.968C301.362,272.579,258.961,250.435,211.478,250.435z"/> <path style="fill:#0052B4;" d="M343.393,273.06c1.072-5.524,1.651-11.223,1.651-17.06c0-49.178-39.866-89.043-89.043-89.043 c-36.694,0-68.194,22.201-81.826,53.899c12.05-2.497,24.526-3.812,37.305-3.812C263.197,217.043,309.983,238.541,343.393,273.06z" /> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'at',
    native_language: {
      code: 'de',
      languageName: 'German',
    },
    name: 'Austria',
    flag_position: '-192px 0',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#F0F0F0;" d="M496.077,345.043C506.368,317.311,512,287.314,512,256s-5.632-61.309-15.923-89.043L256,144.696 L15.923,166.957C5.633,194.691,0,224.686,0,256s5.633,61.311,15.923,89.043L256,367.304L496.077,345.043z"/> <g> <path style="fill:#D80027;" d="M256,512c110.07,0,203.906-69.472,240.076-166.957H15.922C52.094,442.528,145.928,512,256,512z"/> <path style="fill:#D80027;" d="M256,0C145.928,0,52.094,69.472,15.922,166.957h480.155C459.906,69.472,366.07,0,256,0z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'nz',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'New Zealand',
    flag_position: '-112px -110px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#0052B4;" d="M512,256c0,141.384-114.616,256-256,256S0,397.384,0,256C0,256.061,256,0.028,256,0 C397.384,0,512,114.616,512,256z"/> <g> <path style="fill:#F0F0F0;" d="M256,0c-0.014,0-0.029,0-0.043,0H256L256,0z"/> <path style="fill:#F0F0F0;" d="M255.315,256H256c0-0.23,0-0.454,0-0.685C255.772,255.544,255.544,255.772,255.315,256z"/> <path style="fill:#F0F0F0;" d="M256,133.565C256,88.52,256,59.005,256,0h-0.043C114.592,0.024,0,114.629,0,256h133.565v-75.211 L208.777,256h46.539c0.228-0.228,0.457-0.456,0.685-0.685c0-17.247,0-32.636,0-46.537l-75.213-75.213H256z"/> </g> <g> <path style="fill:#D80027;" d="M129.515,33.391C89.476,56.19,56.19,89.476,33.391,129.515V256h66.783V100.176v-0.002H256 c0-21.063,0-41.129,0-66.783H129.515z"/> <path style="fill:#D80027;" d="M256,224.519l-90.953-90.953c0,0-31.481,0.002-31.481,0v0.002L255.999,256H256 C256,256,256,234.293,256,224.519z"/> <polygon style="fill:#D80027;" points="443.33,189.959 448.855,206.965 466.736,206.965 452.27,217.475 457.796,234.48 443.33,223.971 428.863,234.48 434.389,217.475 419.922,206.965 437.803,206.965 \t"/> <polygon style="fill:#D80027;" points="379.411,312.393 387.7,337.903 414.521,337.903 392.821,353.667 401.111,379.176 379.411,363.411 357.711,379.176 366.001,353.667 344.301,337.903 371.122,337.903 \t"/> <polygon style="fill:#D80027;" points="381.825,112.046 388.733,133.305 411.084,133.305 393,146.44 399.908,167.698 381.825,154.559 363.743,167.698 370.65,146.44 352.568,133.305 374.918,133.305 \t"/> <polygon style="fill:#D80027;" points="320.322,189.217 328.61,214.727 355.432,214.727 333.732,230.491 342.022,256 320.322,240.235 298.622,256 306.912,230.491 285.212,214.727 312.033,214.727 \t"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'ru',
    native_language: {
      code: 'ru',
      languageName: 'Russian',
    },
    name: 'Russia',
    flag_position: '-176px -121px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#0052B4;" d="M496.077,345.043C506.368,317.31,512,287.314,512,256s-5.632-61.31-15.923-89.043H15.923 C5.633,194.69,0,224.686,0,256s5.633,61.31,15.923,89.043L256,367.304L496.077,345.043z"/> <path style="fill:#D80027;" d="M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'ie',
    native_language: {
      code: 'ie',
      languageName: 'Interlingue',
    },
    name: 'Ireland',
    flag_position: '-48px -66px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#FF9811;" d="M512,256c0-110.07-69.472-203.906-166.957-240.076v480.155C442.528,459.906,512,366.072,512,256z"/> <path style="fill:#6DA544;" d="M0,256c0,110.072,69.472,203.906,166.957,240.078V15.924C69.472,52.094,0,145.93,0,256z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'no',
    native_language: {
      code: 'nb',
      languageName: 'Norwegian',
    },
    name: 'Norway',
    flag_position: '-48px -110px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <g> <path style="fill:#D80027;" d="M8.819,322.783c14.812,54.959,47.457,102.593,91.355,136.322V322.783H8.819z"/> <path style="fill:#D80027;" d="M233.739,511.026C241.077,511.658,248.498,512,256,512c118.279,0,217.805-80.221,247.181-189.217 H233.739V511.026z"/> <path style="fill:#D80027;" d="M503.181,189.217C473.805,80.221,374.279,0,256,0c-7.502,0-14.923,0.342-22.261,0.974v188.243 H503.181z"/> <path style="fill:#D80027;" d="M100.174,52.895c-43.898,33.73-76.543,81.363-91.355,136.322h91.355V52.895z"/> </g> <path style="fill:#0052B4;" d="M509.833,222.609H200.349h-0.001V6.085c-23.658,5.246-46.087,13.749-66.783,25.042v191.48v0.001 H2.167C0.742,233.539,0,244.683,0,256s0.742,22.461,2.167,33.391h131.397h0.001v191.481c20.696,11.292,43.125,19.797,66.783,25.042 V289.394v-0.002h309.485C511.256,278.461,512,267.317,512,256S511.256,233.539,509.833,222.609z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'hu',
    native_language: {
      code: 'hu',
      languageName: 'Hungarian',
    },
    name: 'Hungary',
    flag_position: '-16px -66px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#F0F0F0;" d="M15.923,166.957C5.633,194.691,0,224.686,0,256s5.633,61.311,15.923,89.043L256,367.304 l240.077-22.261C506.367,317.311,512,287.314,512,256s-5.633-61.309-15.923-89.043L256,144.696L15.923,166.957z"/> <path style="fill:#D80027;" d="M256,0C145.93,0,52.094,69.472,15.924,166.957h480.155C459.906,69.472,366.072,0,256,0z"/> <path style="fill:#6DA544;" d="M256,512c110.072,0,203.906-69.472,240.078-166.957H15.924C52.094,442.528,145.93,512,256,512z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'ro',
    native_language: {
      code: 'ro',
      languageName: 'Romanian',
    },
    name: 'Romania',
    flag_position: '-144px -121px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#FFDA44;" d="M345.043,15.922C317.309,5.633,287.314,0,256,0c-31.314-0.001-61.31,5.633-89.043,15.922 l-22.261,240.077l22.261,240.077C194.689,506.368,224.685,512,256,512c31.313,0,61.31-5.632,89.043-15.924L367.303,256 L345.043,15.922z"/> <path style="fill:#D80027;" d="M512,256c0-110.07-69.472-203.907-166.957-240.077v480.156C442.528,459.905,511.999,366.072,512,256z "/> <path style="fill:#0052B4;" d="M0,255.999c0,110.073,69.472,203.906,166.955,240.079l0.001-480.154 C69.472,52.094,0,145.928,0,255.999z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'dk',
    native_language: {
      code: 'da',
      languageName: 'Danish',
    },
    name: 'Denmark',
    flag_position: '-96px -33px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <g> <path style="fill:#D80027;" d="M200.349,222.609h309.484C493.47,97.002,386.067,0,256,0c-19.115,0-37.732,2.113-55.652,6.085 v216.524H200.349z"/> <path style="fill:#D80027;" d="M133.565,222.608V31.127C63.272,69.481,12.95,139.832,2.167,222.609h131.398V222.608z"/> <path style="fill:#D80027;" d="M133.564,289.391H2.167c10.783,82.777,61.105,153.128,131.398,191.481L133.564,289.391 L133.564,289.391z"/> <path style="fill:#D80027;" d="M200.348,289.392v216.523C218.268,509.887,236.885,512,256,512 c130.067,0,237.47-97.002,253.833-222.609H200.348V289.392z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'fi',
    native_language: {
      code: 'fi',
      languageName: 'Finnish',
    },
    name: 'Finland',
    flag_position: '-48px -44px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#0052B4;" d="M509.833,222.609H200.349h-0.001V6.085c-23.658,5.246-46.087,13.749-66.783,25.042v191.48v0.001 H2.167C0.742,233.539,0,244.683,0,256s0.742,22.461,2.167,33.391h131.397h0.001v191.481c20.696,11.292,43.125,19.797,66.783,25.042 V289.394v-0.002h309.485C511.256,278.461,512,267.317,512,256S511.256,233.539,509.833,222.609z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'sk',
    native_language: {
      code: 'sk',
      languageName: 'Slovak',
    },
    name: 'Slovakia',
    flag_position: '-96px -132px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#0052B4;" d="M256,512c141.384,0,256-114.616,256-256c0-31.314-5.632-61.311-15.923-89.043H15.923 C5.633,194.689,0,224.686,0,256C0,397.384,114.616,512,256,512z"/> <path style="fill:#D80027;" d="M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"/> <path style="fill:#F0F0F0;" d="M66.198,144.696v127.706c0,72.644,94.901,94.903,94.901,94.903s94.9-22.259,94.9-94.903V144.696 H66.198z"/> <path style="fill:#D80027;" d="M88.459,144.696v127.706c0,8.528,1.894,16.582,5.646,24.133c37.234,0,92.886,0,133.987,0 c3.752-7.55,5.646-15.605,5.646-24.133V144.696H88.459z"/> <polygon style="fill:#F0F0F0;" points="205.62,233.739 172.23,233.739 172.23,211.478 194.491,211.478 194.491,189.217 172.23,189.217 172.23,166.957 149.969,166.957 149.969,189.217 127.709,189.217 127.709,211.478 149.969,211.478 149.969,233.739 116.577,233.739 116.577,256 149.969,256 149.969,278.261 172.23,278.261 172.23,256 205.62,256 "/> <path style="fill:#0052B4;" d="M124.471,327.61c14.345,9.015,29.083,14.249,36.628,16.577c7.545-2.327,22.283-7.562,36.628-16.577 c14.466-9.092,24.607-19.49,30.365-31.075c-6.351-4.493-14.1-7.143-22.471-7.143c-3.048,0-6.009,0.361-8.856,1.024 c-6.033-13.708-19.728-23.285-35.665-23.285s-29.633,9.577-35.665,23.285c-2.847-0.663-5.809-1.024-8.856-1.024 c-8.371,0-16.12,2.65-22.471,7.143C99.863,308.119,110.004,318.517,124.471,327.61z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'cz',
    native_language: {
      code: 'cs',
      languageName: 'Czech',
    },
    name: 'Czech Republic',
    flag_position: '-48px -33px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#D80027;" d="M233.739,256c0,0-158.609,181.055-158.759,181.019C121.306,483.346,185.307,512,256,512 c141.384,0,256-114.616,256-256H233.739z"/> <path style="fill:#0052B4;" d="M74.98,74.98c-99.974,99.974-99.974,262.065,0,362.04C116.293,395.707,156.026,355.974,256,256 L74.98,74.98z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'gr',
    native_language: {
      code: 'el',
      languageName: 'Greek',
    },
    name: 'Greece',
    flag_position: '-96px -55px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <g> <path style="fill:#338AF3;" d="M256,189.217h247.181c-6.419-23.814-16.175-46.255-28.755-66.783H256V189.217z"/> <path style="fill:#338AF3;" d="M96.643,456.348h318.713c23.363-18.608,43.399-41.21,59.069-66.783H37.574 C53.245,415.137,73.281,437.74,96.643,456.348z"/> <path style="fill:#338AF3;" d="M89.043,61.939c-20.126,17.331-37.525,37.74-51.469,60.496h51.469V61.939z"/> <path style="fill:#338AF3;" d="M256,256c0-26.076,0-47.899,0-66.783H155.826V256H89.043v-66.783H8.819 C3.08,210.511,0,232.893,0,256s3.08,45.489,8.819,66.783h494.363C508.92,301.489,512,279.107,512,256H256z"/> <path style="fill:#338AF3;" d="M256,0c-35.549,0-69.404,7.253-100.174,20.348v102.087H256c0-23.312,0-43.139,0-66.783h159.357 C371.626,20.824,316.249,0,256,0z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'ba',
    native_language: {
      code: 'bs',
      languageName: 'Bosnian',
    },
    name: 'Bosnia & Herzegovina',
    flag_position: '0px -11px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#FFDA44;" d="M256,0C165.23,0,85.5,47.243,40.044,118.479l347.159,357.37C461.946,431.147,512,349.423,512,256 C512,114.616,397.384,0,256,0z"/> <g> <path style="fill:#0052B4;" d="M512,256c0-66.422-25.298-126.93-66.783-172.428v344.857C486.702,382.93,512,322.422,512,256z"/> <path style="fill:#0052B4;" d="M319.789,481.873l26.815-0.017l8.272-25.509l8.302,25.499l13.45-0.008 c8.247-4.415,16.224-9.267,23.9-14.529L44.689,111.471c-5.864,8.556-11.212,17.49-16.021,26.75l3.162,9.712l26.815-0.017 l-21.684,15.775l8.302,25.499l-21.704-15.748l-12.945,9.416C3.713,206.034,0,230.583,0,256c0,141.384,114.616,256,256,256 c29.892,0,58.583-5.132,85.25-14.552L319.789,481.873z M57.099,244.87l8.27-25.508l-21.702-15.75l26.815-0.017l8.271-25.509 l8.302,25.499l26.815-0.017l-21.685,15.775l8.302,25.499l-21.704-15.748L57.099,244.87z M112.324,300.522l8.27-25.508 l-21.702-15.75l26.815-0.017l8.271-25.509l8.302,25.499l26.815-0.017l-21.684,15.775l8.302,25.499l-21.704-15.748L112.324,300.522z M167.548,356.174l8.27-25.508l-21.702-15.75l26.815-0.017l8.271-25.509l8.302,25.499l26.815-0.017l-21.684,15.775l8.302,25.499 l-21.704-15.75L167.548,356.174z M244.457,396.051l-21.685,15.775l8.27-25.508l-21.702-15.75l26.815-0.017l8.272-25.509 l8.302,25.499l26.815-0.017l-21.684,15.775l8.302,25.499L244.457,396.051z M277.997,467.478l8.27-25.508l-21.702-15.75 l26.815-0.017l8.271-25.509l8.302,25.499l26.815-0.017l-21.684,15.775l8.302,25.499l-21.704-15.75L277.997,467.478z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'rs',
    native_language: {
      code: 'sr',
      languageName: 'Serbian',
    },
    name: 'Serbia',
    flag_position: '-160px -121px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#0052B4;" d="M256,0C114.616,0,0,114.616,0,256c0,31.314,5.633,61.311,15.923,89.043h480.155 C506.368,317.311,512,287.314,512,256C512,114.616,397.384,0,256,0z"/> <g> <path style="fill:#D80027;" d="M256,0C145.929,0,52.094,69.472,15.923,166.957h480.155C459.906,69.472,366.071,0,256,0z"/> <path style="fill:#D80027;" d="M66.198,144.696v127.706c0,72.644,94.901,94.903,94.901,94.903s94.9-22.259,94.9-94.903V144.696 H66.198z"/> </g> <g> <polygon style="fill:#FFDA44;" points="105.446,166.957 216.751,166.957 216.751,122.435 194.49,133.565 161.099,100.174 127.707,133.565 105.446,122.435 \t"/> <polygon style="fill:#FFDA44;" points="233.739,290.183 161.391,217.835 89.043,290.183 112.654,313.794 161.391,265.057 210.128,313.794 \t"/> </g> <path style="fill:#F0F0F0;" d="M233.739,222.609h-33.756c1.898-3.276,3.002-7.07,3.002-11.128c0-12.296-9.967-22.261-22.261-22.261 c-8.495,0-15.872,4.758-19.625,11.753c-3.753-6.994-11.13-11.753-19.625-11.753c-12.294,0-22.261,9.965-22.261,22.261 c0,4.058,1.104,7.853,3.002,11.128H89.043c0,12.295,10.709,22.261,23.002,22.261h-0.741c0,12.295,9.966,22.261,22.261,22.261 c0,10.886,7.818,19.93,18.143,21.866l-17.54,39.602c8.406,3.417,17.592,5.315,27.224,5.315c9.632,0,18.818-1.898,27.224-5.315 l-17.54-39.602c10.325-1.934,18.143-10.979,18.143-21.866c12.295,0,22.261-9.966,22.261-22.261h-0.741 C223.031,244.87,233.739,234.903,233.739,222.609z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'za',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'South Africa',
    flag_position: '-48px -165px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path d="M74.98,437.02c-99.974-99.975-99.974-262.065,0-362.04C74.973,74.991,222.609,256,222.609,256L74.98,437.02z"/> <path style="fill:#FFDA44;" d="M222.609,256L33.953,128.513c-5.849,10.167-11.007,20.779-15.439,31.763l95.509,95.725l-95.506,95.73 c4.428,10.976,9.581,21.581,15.426,31.741L222.609,256z"/> <path style="fill:#6DA544;" d="M509.833,222.609H222.602L74.978,74.984c-15.908,15.908-29.729,33.899-41.025,53.53L161.192,256 L33.943,383.47c11.296,19.636,25.123,37.633,41.035,53.545l147.624-147.624h287.231C511.256,278.461,512,267.317,512,256 C512,244.683,511.256,233.539,509.833,222.609z"/> <path style="fill:#0052B4;" d="M100.138,459.077C143.307,492.259,197.344,512,256,512c118.279,0,217.805-80.221,247.181-189.217 H236.433L100.138,459.077z"/> <path style="fill:#D80027;" d="M503.181,189.217C473.805,80.221,374.279,0,256,0c-58.656,0-112.693,19.741-155.862,52.923 l136.294,136.294H503.181z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'ke',
    native_language: {
      code: 'sw',
      languageName: 'Swahili',
    },
    name: 'Kenya',
    flag_position: '0 -77px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path d="M256,0C154.506,0,66.81,59.065,25.402,144.696h461.195C445.19,59.065,357.493,0,256,0z"/> <path style="fill:#496E2D;" d="M256,512c-101.494,0-189.19-59.065-230.598-144.696h461.195C445.19,452.935,357.493,512,256,512z"/> <path style="fill:#A2001D;" d="M499.911,178.087H12.089C4.247,202.656,0,228.831,0,256s4.247,53.344,12.089,77.913H499.91 C507.753,309.344,512,283.169,512,256S507.753,202.656,499.911,178.087z"/> <g> <polygon style="fill:#F0F0F0;" points="335.715,118.301 305.398,104.308 256,216.159 206.602,104.308 176.285,118.301 237.613,256 176.285,393.699 206.602,407.692 256,295.841 305.398,407.692 335.715,393.699 274.387,256 \t"/> <path style="fill:#F0F0F0;" d="M276.591,131.489C264.855,118.672,256,111.304,256,111.304s-8.855,7.367-20.591,20.185v249.02 C247.145,393.328,256,400.696,256,400.696s8.855-7.367,20.591-20.186V131.489z"/> </g> <g> <path style="fill:#A2001D;" d="M200.348,179.243v153.512c12.402,21.975,27.581,39.987,38.957,51.929V127.315 C227.929,139.256,212.749,157.269,200.348,179.243z"/> <path style="fill:#A2001D;" d="M311.652,179.243c-12.403-21.975-27.581-39.987-38.957-51.928v257.369 c11.375-11.942,26.554-29.954,38.957-51.929V179.243z"/> </g> <path d="M311.652,179.243v153.512c12.555-22.249,22.261-48.558,22.261-76.755S324.207,201.493,311.652,179.243z"/> <path d="M200.348,179.243v153.512c-12.555-22.249-22.261-48.558-22.261-76.755S187.793,201.493,200.348,179.243z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'gh',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'Ghana',
    flag_position: '-240px -44px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#FFDA44;" d="M0,256c0,31.314,5.633,61.31,15.923,89.043L256,356.174l240.077-11.13 C506.368,317.31,512,287.314,512,256s-5.632-61.31-15.923-89.043L256,155.826l-240.077,11.13C5.633,194.69,0,224.686,0,256z"/> <path style="fill:#D80027;" d="M256,0C145.929,0,52.094,69.472,15.923,166.957h480.155C459.906,69.472,366.071,0,256,0z"/> <path style="fill:#496E2D;" d="M496.077,345.043H15.923C52.094,442.527,145.929,512,256,512S459.906,442.527,496.077,345.043z"/> <polygon points="255.998,166.957 278.098,234.977 349.626,234.977 291.763,277.02 313.863,345.043 255.998,303.003 198.133,345.043 220.237,277.02 162.374,234.977 233.898,234.977 "/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'eg',
    native_language: {
      code: 'ar',
      languageName: 'Arabic',
    },
    name: 'Egypt',
    flag_position: '-192px -33px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#D80027;" d="M256,0C145.929,0,52.094,69.472,15.923,166.957h480.155C459.906,69.472,366.071,0,256,0z"/> <path d="M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"/> <path style="fill:#FF9811;" d="M345.043,228.174h-66.783c0-12.294-9.967-22.261-22.261-22.261s-22.261,9.967-22.261,22.261h-66.783 c0,12.295,10.709,22.261,23.003,22.261h-0.742c0,12.295,9.966,22.261,22.261,22.261c0,12.295,9.966,22.261,22.261,22.261h44.522 c12.295,0,22.261-9.966,22.261-22.261c12.295,0,22.261-9.966,22.261-22.261h-0.741C334.335,250.435,345.043,240.469,345.043,228.174 z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'et',
    native_language: {
      code: 'am',
      languageName: 'Amharic',
    },
    name: 'Ethiopia',
    flag_position: '-16px -44px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#FFDA44;" d="M0,256c0,31.316,5.633,61.312,15.924,89.046L256,367.304l240.076-22.259 C506.368,317.312,512,287.315,512,256c0-30.885-5.471-60.492-15.494-87.905L256,144.696l-240.506,23.4 C5.471,195.508,0,225.115,0,256z"/> <path style="fill:#D80027;" d="M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"/> <path style="fill:#6DA544;" d="M256,0C145.929,0,52.094,69.472,15.923,166.957h480.155C459.906,69.472,366.071,0,256,0z"/> <circle style="fill:#0052B4;" cx="256" cy="256" r="122.435"/> <g> <polygon style="fill:#FFDA44;" points="255.974,161.191 278.076,229.213 349.713,229.213 291.735,271.254 314.011,339.478 255.974,297.237 198.026,339.4 220.212,271.254 162.287,229.213 233.872,229.213 \t"/> <polygon style="fill:#FFDA44;" points="344.124,272.93 274.008,250.146 317.341,190.506 299.333,177.42 255.998,237.064 212.667,177.421 194.657,190.505 237.989,250.15 167.876,272.929 174.754,294.102 244.87,271.321 244.87,345.043 267.13,345.043 267.13,271.32 337.243,294.102 \t"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'mw',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'Malawi',
    flag_position: '-128px -99px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#D80027;" d="M0,256c0,31.314,5.633,61.31,15.923,89.043L256,356.174l240.077-11.13 C506.368,317.31,512,287.314,512,256s-5.632-61.31-15.923-89.043L256,155.826l-240.077,11.13C5.633,194.69,0,224.686,0,256z"/> <path d="M256,0C145.929,0,52.094,69.472,15.923,166.957h480.155C459.906,69.472,366.071,0,256,0z"/> <path style="fill:#496E2D;" d="M496.077,345.043H15.923C52.094,442.527,145.929,512,256,512S459.906,442.527,496.077,345.043z"/> <polygon style="fill:#D80027;" points="332.515,122.435 301.251,107.729 317.9,77.45 283.95,83.945 279.648,49.647 256,74.872 232.353,49.647 228.05,83.945 194.101,77.45 210.75,107.729 179.485,122.435 "/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'pt',
    native_language: {
      code: 'pt',
      languageName: 'portuguese',
    },
    name: 'Portugal',
    flag_position: '-64px -121px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#6DA544;" d="M0,256c0,110.07,69.472,203.905,166.955,240.076l22.262-240.077L166.955,15.923 C69.472,52.095,0,145.929,0,256z"/> <path style="fill:#D80027;" d="M512,256C512,114.616,397.384,0,256,0c-31.314,0-61.311,5.633-89.045,15.923v480.154 C194.689,506.368,224.686,512,256,512C397.384,512,512,397.384,512,256z"/> <circle style="fill:#FFDA44;" cx="166.957" cy="256" r="89.043"/> <path style="fill:#D80027;" d="M116.87,211.478v55.652c0,27.662,22.424,50.087,50.087,50.087s50.087-22.424,50.087-50.087v-55.652 H116.87z"/> <path style="fill:#F0F0F0;" d="M166.957,283.826c-9.206,0-16.696-7.49-16.696-16.696V244.87h33.391v22.261 C183.652,276.336,176.162,283.826,166.957,283.826z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'tr',
    native_language: {
      code: 'tr',
      languageName: 'Turkish',
    },
    name: 'Turkey',
    flag_position: '-192px -143px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#D80027;" cx="256" cy="256" r="256"/> <g> <polygon style="fill:#F0F0F0;" points="245.518,209.186 266.523,238.131 300.54,227.101 279.502,256.021 300.504,284.965 266.499,273.893 245.462,302.813 245.484,267.052 211.478,255.98 245.496,244.95 \t"/> <path style="fill:#F0F0F0;" d="M188.194,328.348c-39.956,0-72.348-32.392-72.348-72.348s32.392-72.348,72.348-72.348 c12.458,0,24.18,3.151,34.414,8.696c-16.055-15.702-38.012-25.392-62.24-25.392c-49.178,0-89.043,39.866-89.043,89.043 s39.866,89.043,89.043,89.043c24.23,0,46.186-9.691,62.24-25.392C212.374,325.197,200.652,328.348,188.194,328.348z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'mx',
    native_language: {
      code: 'es',
      languageName: 'Español',
    },
    name: 'Mexico',
    flag_position: '-144px -99px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#D80027;" d="M512,256c0-101.494-59.065-189.19-144.696-230.598v461.195C452.935,445.19,512,357.494,512,256z"/> <g> <path style="fill:#6DA544;" d="M0,256c0,101.494,59.065,189.19,144.696,230.598V25.402C59.065,66.81,0,154.506,0,256z"/> <path style="fill:#6DA544;" d="M189.217,256c0,36.883,29.9,66.783,66.783,66.783s66.783-29.9,66.783-66.783v-22.261H189.217V256z" /> </g> <path style="fill:#FF9811;" d="M345.043,211.478h-66.783c0-12.294-9.967-22.261-22.261-22.261s-22.261,9.967-22.261,22.261h-66.783 c0,12.295,10.709,22.261,23.002,22.261h-0.741c0,12.295,9.966,22.261,22.261,22.261c0,12.295,9.966,22.261,22.261,22.261h44.522 c12.295,0,22.261-9.966,22.261-22.261c12.295,0,22.261-9.966,22.261-22.261h-0.742C334.335,233.739,345.043,223.773,345.043,211.478 z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'se',
    native_language: {
      code: 'sv',
      languageName: 'Swedish',
    },
    name: 'Sweden',
    flag_position: '-32px -132px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#FFDA44;" cx="256" cy="256" r="256"/> <g> <path style="fill:#0052B4;" d="M200.349,222.609h309.484C493.47,97.002,386.067,0,256,0c-19.114,0-37.733,2.113-55.652,6.085 v216.524H200.349z"/> <path style="fill:#0052B4;" d="M133.565,222.608V31.127C63.271,69.481,12.95,139.832,2.167,222.609h131.398V222.608z"/> <path style="fill:#0052B4;" d="M133.564,289.391H2.167c10.783,82.777,61.104,153.128,131.398,191.481L133.564,289.391 L133.564,289.391z"/> <path style="fill:#0052B4;" d="M200.348,289.392v216.523C218.267,509.887,236.886,512,256,512 c130.067,0,237.47-97.002,253.833-222.609H200.348V289.392z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'nl',
    native_language: {
      code: 'nl',
      languageName: 'Dutch',
    },
    name: 'Netherlands',
    flag_position: '-32px -110px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#A2001D;" d="M256,0C145.929,0,52.094,69.472,15.923,166.957h480.155C459.906,69.472,366.071,0,256,0z"/> <path style="fill:#0052B4;" d="M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'hr',
    native_language: {
      code: 'hr',
      languageName: 'Croatian',
    },
    name: 'Croatia',
    flag_position: '-240px -55px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <path style="fill:#F0F0F0;" d="M512,256c0-31.314-5.633-61.311-15.923-89.043L256,155.826l-240.077,11.13 C5.633,194.689,0,224.686,0,256s5.633,61.311,15.923,89.043L256,356.174l240.077-11.13C506.367,317.311,512,287.314,512,256z"/> <path style="fill:#0052B4;" d="M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"/> <path style="fill:#D80027;" d="M15.923,166.957h480.155C459.906,69.472,366.071,0,256,0S52.094,69.472,15.923,166.957z"/> <g> <polygon style="fill:#338AF3;" points="322.783,178.088 278.261,178.088 285.682,122.435 315.362,100.174 345.043,122.435 345.043,166.957 \t"/> <polygon style="fill:#338AF3;" points="189.217,178.088 233.739,178.088 226.318,122.435 196.637,100.174 166.957,122.435 166.957,166.957 \t"/> </g> <polygon style="fill:#0052B4;" points="285.682,178.088 226.318,178.088 226.318,122.435 256,100.174 285.682,122.435 "/> <path style="fill:#F0F0F0;" d="M166.957,166.958v122.434c0,29.153,14.082,55.079,35.802,71.332l15.583-3.899l19.664,19.782 c5.815,1.198,11.832,1.829,17.995,1.829c6.13,0,12.117-0.623,17.901-1.809l22.447-18.69l12.892,2.751 c21.711-16.252,35.803-42.151,35.803-71.296V166.958H166.957z"/> <g> <rect x="166.957" y="166.957" style="fill:#D80027;" width="35.617" height="35.617"/> <rect x="238.191" y="166.957" style="fill:#D80027;" width="35.617" height="35.617"/> <rect x="309.426" y="166.957" style="fill:#D80027;" width="35.617" height="35.617"/> <rect x="202.574" y="202.574" style="fill:#D80027;" width="35.617" height="35.617"/> <rect x="273.809" y="202.574" style="fill:#D80027;" width="35.617" height="35.617"/> <rect x="166.957" y="238.18" style="fill:#D80027;" width="35.617" height="35.617"/> <rect x="202.574" y="273.798" style="fill:#D80027;" width="35.617" height="35.617"/> <rect x="238.191" y="238.18" style="fill:#D80027;" width="35.617" height="35.617"/> <rect x="309.426" y="238.18" style="fill:#D80027;" width="35.617" height="35.617"/> <rect x="273.809" y="273.798" style="fill:#D80027;" width="35.617" height="35.617"/> <rect x="238.191" y="309.415" style="fill:#D80027;" width="35.617" height="35.617"/> <path style="fill:#D80027;" d="M202.574,309.418h-33.319c3.056,13.24,9.064,25.355,17.302,35.617h16.017V309.418z"/> <path style="fill:#D80027;" d="M309.426,345.036h16.016c8.24-10.262,14.246-22.378,17.302-35.617h-33.318V345.036z"/> <path style="fill:#D80027;" d="M202.574,345.036v15.541c10.359,7.795,22.465,13.384,35.617,16.066v-31.607H202.574z"/> <path style="fill:#D80027;" d="M273.809,345.036v31.607c13.153-2.68,25.258-8.271,35.617-16.066v-15.541H273.809z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'mk',
    native_language: {
      code: 'mk',
      languageName: 'Macedonian',
    },
    name: 'Macedonia',
    flag_position: '-192px -88px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#FFDA44;" cx="256" cy="256" r="256"/> <g> <path style="fill:#D80027;" d="M294.932,509.057c41.636-6.352,79.962-22.748,112.456-46.618L256,256L294.932,509.057z"/> <path style="fill:#D80027;" d="M217.067,2.943C175.432,9.295,137.106,25.691,104.61,49.56L256,256L217.067,2.943z"/> <path style="fill:#D80027;" d="M104.61,462.439c32.494,23.869,70.82,40.265,112.455,46.619L256,256L104.61,462.439z"/> <path style="fill:#D80027;" d="M49.56,104.61C25.69,137.106,9.296,175.431,2.943,217.067L256,256L49.56,104.61z"/> <path style="fill:#D80027;" d="M2.943,294.932c6.352,41.636,22.748,79.962,46.618,112.456L256,256L2.943,294.932z"/> <path style="fill:#D80027;" d="M509.057,217.067c-6.353-41.635-22.748-79.961-46.618-112.456L256,256L509.057,217.067z"/> <path style="fill:#D80027;" d="M407.388,49.559C374.893,25.69,336.568,9.295,294.932,2.943L256,256L407.388,49.559z"/> <path style="fill:#D80027;" d="M462.441,407.389c23.869-32.495,40.264-70.822,46.618-112.456L256,256L462.441,407.389z"/> <circle style="fill:#D80027;" cx="256" cy="256" r="89.043"/> </g> <circle style="fill:#FFDA44;" cx="256" cy="256" r="66.783"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'do',
    native_language: {
      code: 'es',
      languageName: 'Español',
    },
    name: 'Dominican Republic',
    flag_position: '-128px -33px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#D80027;" d="M8.819,322.783c23.638,87.703,92.695,156.761,180.399,180.399V322.783H8.819z"/> <path style="fill:#0052B4;" d="M189.217,8.819C101.514,32.456,32.456,101.514,8.819,189.217h180.399V8.819z"/> <path style="fill:#D80027;" d="M503.181,189.217C479.544,101.514,410.486,32.456,322.783,8.819v180.399H503.181z"/> <path style="fill:#0052B4;" d="M322.783,503.181c87.703-23.638,156.761-92.695,180.399-180.399H322.783V503.181z"/> <path style="fill:#496E2D;" d="M322.783,256c0,36.884-29.899,66.783-66.783,66.783c-36.883,0-66.783-29.899-66.783-66.783 S256,189.217,256,189.217S322.783,219.116,322.783,256z"/> <path style="fill:#0052B4;" d="M189.217,256c0-36.884,29.9-66.783,66.783-66.783c36.884,0,66.783,29.899,66.783,66.783"/> <path style="fill:#D80027;" d="M218.435,222.609v41.739c0,20.747,16.818,37.565,37.565,37.565s37.565-16.818,37.565-37.565v-41.739 H218.435z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'al',
    native_language: {
      code: 'sq',
      languageName: 'Albanian',
    },
    name: 'Albania',
    flag_position: '-96px 0',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#D80027;" cx="256" cy="256" r="256"/> <path d="M400.696,190.009H307.97c5.724-5.994,9.247-14.109,9.247-23.052c0-18.441-14.95-33.391-33.391-33.391 c-11.618,0-21.845,5.936-27.826,14.937c-5.981-9.001-16.209-14.937-27.826-14.937c-18.441,0-33.391,14.95-33.391,33.391 c0,8.943,3.523,17.059,9.247,23.052h-92.725c0,24.589,21.417,44.521,46.004,44.521h-1.484c0,24.59,19.933,44.523,44.523,44.523 c0,7.964,2.099,15.43,5.763,21.894l-36.93,36.931l28.334,28.332l40.192-40.191c1.574,0.577,3.203,1.04,4.885,1.355l-24.287,54.835 L256,422.957l37.695-40.75l-24.287-54.835c1.683-0.315,3.311-0.777,4.885-1.355l40.192,40.191l28.334-28.333l-36.931-36.931 c3.665-6.463,5.764-13.93,5.764-21.894c24.589,0,44.522-19.932,44.522-44.523h-1.483 C379.278,234.529,400.696,214.598,400.696,190.009z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'id',
    native_language: {
      code: 'id',
      languageName: 'Indonesian',
    },
    name: 'Indonesia',
    flag_position: '-32px -66px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#A2001D;" d="M0,256C0,114.616,114.616,0,256,0s256,114.616,256,256"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'ph',
    native_language: {
      code: 'fl',
      languageName: 'Filipino',
    },
    name: 'Philippines',
    flag_position: '-208px -110px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#D80027;" d="M256,0v256L74.98,437.02C121.307,483.346,185.307,512,256,512c141.384,0,256-114.616,256-256 S256,0,256,0z"/> <path style="fill:#0052B4;" d="M256,0C185.307,0,121.307,28.654,74.98,74.98C137.79,137.79,160.087,160.088,256,256h256 C512,114.616,397.384,0,256,0z"/> <g> <polygon style="fill:#FFDA44;" points="175.291,256 144.027,241.294 160.676,211.015 126.726,217.51 122.424,183.213 98.776,208.437 75.129,183.213 70.826,217.51 36.877,211.014 53.526,241.294 22.261,256 53.526,270.706 36.877,300.985 70.829,294.491 75.128,328.787 98.776,303.563 122.424,328.787 126.726,294.491 160.674,300.986 144.026,270.707 \t"/> <polygon style="fill:#FFDA44;" points="68.273,100.174 78.677,114.717 95.722,109.318 85.104,123.706 95.508,138.249 78.542,132.598 67.925,146.985 68.058,129.105 51.093,123.453 68.141,118.054 \t"/> <polygon style="fill:#FFDA44;" points="68.273,365.015 78.677,379.558 95.722,374.158 85.104,388.547 95.508,403.09 78.542,397.439 67.925,411.826 68.058,393.946 51.093,388.294 68.141,382.895 \t"/> <polygon style="fill:#FFDA44;" points="216.666,232.595 206.263,247.138 189.217,241.737 199.835,256.126 189.431,270.67 206.397,265.018 217.015,279.405 216.881,261.526 233.846,255.874 216.799,250.475 \t"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'il',
    native_language: {
      code: 'he',
      languageName: 'Hebrew',
    },
    name: 'Israel',
    flag_position: '-224px -132px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <g> <path style="fill:#0052B4;" d="M352.393,200.348H288.13L256,144.696l-32.129,55.652h-64.264L191.741,256l-32.134,55.652h64.264 L256,367.304l32.13-55.652h64.263L320.259,256L352.393,200.348z M295.475,256l-19.736,34.188h-39.475L216.525,256l19.738-34.188 h39.475L295.475,256z M256,187.623l7.346,12.724h-14.69L256,187.623z M196.786,221.812h14.692l-7.346,12.724L196.786,221.812z M196.786,290.188l7.347-12.724l7.346,12.724H196.786z M256,324.376l-7.345-12.724h14.691L256,324.376z M315.214,290.188h-14.692 l7.347-12.724L315.214,290.188z M300.522,221.812h14.692l-7.346,12.724L300.522,221.812z"/> <path style="fill:#0052B4;" d="M415.357,55.652H96.643c-23.363,18.608-43.399,41.21-59.069,66.783h436.852 C458.755,96.863,438.719,74.26,415.357,55.652z"/> <path style="fill:#0052B4;" d="M96.643,456.348h318.713c23.363-18.608,43.399-41.21,59.069-66.783H37.574 C53.245,415.137,73.281,437.74,96.643,456.348z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'si',
    native_language: {
      code: 'sl',
      languageName: 'Slovenian',
    },
    name: 'Slovenia',
    flag_position: '-96px -132px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <path style="fill:#0052B4;" d="M496.077,166.957H222.609v-66.783H89.043v66.783h-73.12C5.633,194.689,0,224.686,0,256 s5.633,61.31,15.923,89.043L256,367.304l240.077-22.261C506.367,317.31,512,287.314,512,256S506.367,194.689,496.077,166.957z"/> <path style="fill:#D80027;" d="M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"/> <path style="fill:#F0F0F0;" d="M89.043,166.957v22.26c0,51.121,66.783,66.784,66.783,66.784s66.783-15.663,66.783-66.784v-22.26 l-22.261,22.261l-44.522-33.391l-44.522,33.391L89.043,166.957z"/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'ng',
    native_language: {
      code: 'en',
      languageName: 'English',
    },
    name: 'Nigeria',
    flag_position: '0px -110px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/> <g> <path style="fill:#6DA544;" d="M0,256c0,110.072,69.472,203.906,166.957,240.078V15.924C69.472,52.094,0,145.93,0,256z"/> <path style="fill:#6DA544;" d="M512,256c0-110.07-69.472-203.906-166.957-240.076v480.155C442.528,459.906,512,366.072,512,256z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'vn',
    native_language: {
      code: 'vi',
      languageName: 'Vietnamese',
    },
    name: 'Vietnam',
    flag_position: '-192px -154px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"> <circle style="fill:#D80027;" cx="256" cy="256" r="256"/> <polygon style="fill:#FFDA44;" points="256,133.565 283.628,218.594 373.033,218.594 300.702,271.144 328.33,356.174 256,303.623 183.67,356.174 211.298,271.144 138.968,218.594 228.372,218.594 "/> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>',
  },
  {
    code: 'cn',
    native_language: {
      code: 'zh',
      languageName: 'Chinese',
    },
    name: 'China',
    flag_position: '-208px -21px',
    flag: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-49 141 512 512" style="enable-background:new -49 141 512 512;" xml:space="preserve"><style type="text/css">.st0{fill:#D80027}.st1{fill:#FFDA44}</style><circle class="st0" cx="207" cy="397" r="256"/> <g> <polygon class="st1" points="91.1,296.8 113.2,364.8 184.7,364.8 126.9,406.9 149,474.9 91.1,432.9 33.2,474.9 55.4,406.9 -2.5,364.8 69,364.8 \t"/> <polygon class="st1" points="254.5,537.5 237.6,516.7 212.6,526.4 227.1,503.9 210.2,483 236.1,489.9 250.7,467.4 252.1,494.2 278.1,501.1 253,510.7 \t"/> <polygon class="st1" points="288.1,476.5 296.1,450.9 274.2,435.4 301,435 308.9,409.4 317.6,434.8 344.4,434.5 322.9,450.5 331.5,475.9 309.6,460.4 \t"/> <polygon class="st1" points="333.4,328.9 321.6,353 340.8,371.7 314.3,367.9 302.5,391.9 297.9,365.5 271.3,361.7 295.1,349.2 290.5,322.7 309.7,341.4 \t"/> <polygon class="st1" points="255.2,255.9 253.2,282.6 278.1,292.7 252,299.1 250.1,325.9 236,303.1 209.9,309.5 227.2,289 213,266.3 237.9,276.4 \t"/> </g> </svg>',
  },
  // {
  //     code: 'jp',
  //     native_language: {
  //         code: 'ja',
  //         languageName: 'Japanese'
  //     },
  //     name: 'Japan',
  //     flag_position: '-240px -66px'
  // },
]
export const videosRegion = [
  {
    name: 'All',
    code: 'all',
    position: '1.125rem',
  },
  {
    name: 'Algeria',
    code: 'DZ',
    position: '1.125rem',
  },
  {
    name: 'Argentina',
    code: 'AR',
    position: '1.125rem',
  },
  {
    name: 'Australia',
    code: 'AU',
    position: '1.125rem',
  },
  {
    name: 'Austria',
    code: 'AT',
    position: '1.125rem',
  },
  {
    name: 'Azerbaijan',
    code: 'AZ',
    position: '1.125rem',
  },
  {
    name: 'Bahrain',
    code: 'BH',
    position: '1.125rem',
  },
  {
    name: 'Belarus',
    code: 'BY',
    position: '1.125rem',
  },
  {
    name: 'Belgium',
    code: 'BE',
    position: '1.125rem',
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    position: '1.125rem',
  },
  {
    name: 'Brazil',
    code: 'BR',
    position: '1.125rem',
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    position: '1.125rem',
  },
  {
    name: 'Canada',
    code: 'CA',
    position: '1.125rem',
  },
  {
    name: 'Chile',
    code: 'CL',
    position: '1.125rem',
  },
  {
    name: 'Colombia',
    code: 'CO',
    position: '1.125rem',
  },
  {
    name: 'Croatia',
    code: 'HR',
    position: '1.125rem',
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
    position: '1.125rem',
  },
  {
    name: 'Denmark',
    code: 'DK',
    position: '1.125rem',
  },
  {
    name: 'Egypt',
    code: 'EG',
    position: '1.125rem',
  },
  {
    name: 'Estonia',
    code: 'EE',
    position: '1.125rem',
  },
  {
    name: 'Finland',
    code: 'FI',
    position: '1.125rem',
  },
  {
    name: 'France',
    code: 'FR',
    position: '1.125rem',
  },
  {
    name: 'Georgia',
    code: 'GE',
    position: '1.125rem',
  },
  {
    name: 'Germany',
    code: 'DE',
    position: '1.125rem',
  },
  {
    name: 'Ghana',
    code: 'GH',
    position: '1.125rem',
  },
  {
    name: 'Greece',
    code: 'GR',
    position: '1.125rem',
  },
  {
    name: 'Hong Kong',
    code: 'HK',
    position: '1.125rem',
  },
  {
    name: 'Hungary',
    code: 'HU',
    position: '1.125rem',
  },
  {
    name: 'Iceland',
    code: 'IS',
    position: '1.125rem',
  },
  {
    name: 'India',
    code: 'IN',
    position: '1.125rem',
  },
  {
    name: 'Indonesia',
    code: 'ID',
    position: '1.125rem',
  },
  {
    name: 'Iraq',
    code: 'IQ',
    position: '1.125rem',
  },
  {
    name: 'Ireland',
    code: 'IE',
  },
  {
    name: 'Israel',
    code: 'IL',
    position: '1.125rem',
  },
  {
    name: 'Italy',
    code: 'IT',
    position: '1.125rem',
  },
  {
    name: 'Jamaica',
    code: 'JM',
    position: '1.125rem',
  },
  {
    name: 'Japan',
    code: 'JP',
    position: '1.125rem',
  },
  {
    name: 'Jordan',
    code: 'JO',
    position: '1.125rem',
  },
  {
    name: 'Kazakhstan',
    code: 'KZ',
    position: '1.125rem',
  },
  {
    name: 'Kenya',
    code: 'KE',
    position: '1.125rem',
  },
  {
    name: 'Kuwait',
    code: 'KW',
    position: '1.125rem',
  },
  {
    name: 'Latvia',
    code: 'LV',
    position: '1.125rem',
  },
  {
    name: 'Lebanon',
    code: 'LB',
    position: '1.125rem',
  },
  {
    name: 'Libya',
    code: 'LY',
    position: '1.125rem',
  },
  {
    name: 'Lithuania',
    code: 'LT',
    position: '1.125rem',
  },
  {
    name: 'Luxembourg',
    code: 'LU',
    position: '1.125rem',
  },
  {
    name: 'Macedonia',
    code: 'MK',
    position: '1.125rem',
  },
  {
    name: 'Malaysia',
    code: 'MY',
    position: '1.125rem',
  },
  {
    name: 'Mexico',
    code: 'MX',
    position: '1.125rem',
  },
  {
    name: 'Montenegro',
    code: 'ME',
    position: '1.125rem',
  },
  {
    name: 'Morocco',
    code: 'MA',
    position: '1.125rem',
  },
  {
    name: 'Nepal',
    code: 'NP',
    position: '1.125rem',
  },
  {
    name: 'Netherlands',
    code: 'NL',
    position: '1.125rem',
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    position: '1.125rem',
  },
  {
    name: 'Nigeria',
    code: 'NG',
    position: '1.125rem',
  },
  {
    name: 'Norway',
    code: 'NO',
    position: '1.125rem',
  },
  {
    name: 'Oman',
    code: 'OM',
    position: '1.125rem',
  },
  {
    name: 'Pakistan',
    code: 'PK',
    position: '1.125rem',
  },
  {
    name: 'Peru',
    code: 'PE',
    position: '1.125rem',
  },
  {
    name: 'Philippines',
    code: 'PH',
    position: '1.125rem',
  },
  {
    name: 'Poland',
    code: 'PL',
    position: '1.125rem',
  },
  {
    name: 'Portugal',
    code: 'PT',
    position: '1.125rem',
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
    position: '1.125rem',
  },
  {
    name: 'Qatar',
    code: 'QA',
    position: '1.125rem',
  },
  {
    name: 'Romania',
    code: 'RO',
    position: '1.125rem',
  },
  {
    name: 'Russia',
    code: 'RU',
    position: '1.125rem',
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
    position: '1.125rem',
  },
  {
    name: 'Senegal',
    code: 'SN',
    position: '1.125rem',
  },
  {
    name: 'Serbia',
    code: 'RS',
    position: '1.125rem',
  },
  {
    name: 'Singapore',
    code: 'SG',
    position: '1.125rem',
  },
  {
    name: 'Slovakia',
    code: 'SK',
    position: '1.125rem',
  },
  {
    name: 'Slovenia',
    code: 'SI',
    position: '1.125rem',
  },
  {
    name: 'South Africa',
    code: 'ZA',
    position: '1.125rem',
  },
  {
    name: 'South Korea',
    code: 'KR',
    position: '1.125rem',
  },
  {
    name: 'Spain',
    code: 'ES',
    position: '1.125rem',
  },
  {
    name: 'Sri Lanka',
    code: 'LK',
    position: '1.125rem',
  },
  {
    name: 'Sweden',
    code: 'SE',
    position: '1.125rem',
  },
  {
    name: 'Switzerland',
    code: 'CH',
    position: '1.125rem',
  },
  {
    name: 'Taiwan',
    code: 'TW',
    position: '1.125rem',
  },
  {
    name: 'Tanzania',
    code: 'TZ',
    position: '1.125rem',
  },
  {
    name: 'Thailand',
    code: 'TH',
    position: '1.125rem',
  },
  {
    name: 'Tunisia',
    code: 'TN',
    position: '1.125rem',
  },
  {
    name: 'Turkey',
    code: 'TR',
    position: '1.125rem',
  },
  {
    name: 'Uganda',
    code: 'UG',
    position: '1.125rem',
  },
  {
    name: 'Ukraine',
    code: 'UA',
    position: '1.125rem',
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
    position: '1.125rem',
  },
  {
    name: 'United Kingdom',
    code: 'GB',
    position: '1.125rem',
  },
  {
    name: 'United States',
    code: 'US',
    position: '1.125rem',
  },
  {
    name: 'Vietnam',
    code: 'VN',
    position: '1.125rem',
  },
  {
    name: 'Yemen',
    code: 'YE',
    position: '1.125rem',
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
    position: '1.125rem',
  },
]
